
// For local development
// const host = "localhost";

// For production or staging environment
const host = process.env.REACT_APP_API_HOST;
export const WEBSOCKET_HOST = process.env.REACT_APP_WEBSOCKET_HOST ;
export default host;